export const featureFlags = {
  multiStore: 'sos-171-KO-multi-stores',
  koNameInput: 'SOS-268-KO-Name-Input',
  piedPiper: 'PP-35_pied-piper',
  networkMonitoring: 'network-monitoring',
  merchantAnalytics: 'merchant-app-analytics',
  kodyOrderDiscounts: 'kodyorder-discounts',
  newImageLogic: 'SOS-811-Legacy-KO-New-Image-Logic',
};
